<ng-container *ngIf="dataSource.data.length > 0">
  <div class="header heading-h6-regular">Option-to-purchase:</div>
  <table
    class="mat-elevation-z8 tb-container"
    mat-table
    multiTemplateDataRows
    matSort
    [dataSource]="dataSource"
    *ngIf="dataSource.data.length > 0"
  >
    <ng-container
      matColumnDef="{{ column }}"
      *ngFor="let column of columnsToDisplay"
    >
      <div *ngIf="column === 'displayItemNumber'">
        <th mat-header-cell *matHeaderCellDef>Item no.</th>
      </div>
      <div *ngIf="column === 'Description'">
        <th mat-header-cell *matHeaderCellDef>Item description</th>
      </div>
      <div *ngIf="column === 'Quantity'">
        <th mat-header-cell *matHeaderCellDef>Qty</th>
      </div>
      <div *ngIf="column === 'CurrencyCode'">
        <th mat-header-cell *matHeaderCellDef>Currency</th>
      </div>
      <div *ngIf="column === 'EstimatedUnitPrice'">
        <th mat-header-cell *matHeaderCellDef>UnitPrice</th>
      </div>
      <div *ngIf="column === 'UnitOfMeasurements'">
        <th mat-header-cell *matHeaderCellDef>UoM</th>
      </div>
      <div *ngIf="column === 'DurationYears'">
        <th mat-header-cell *matHeaderCellDef>Years</th>
      </div>
      <div *ngIf="column === 'DurationMonths'">
        <th mat-header-cell *matHeaderCellDef>Months</th>
      </div>
      <div>
        <td
          mat-cell
          *matCellDef="let element"
        >
          {{ column === "displayItemNumber" ? (element['displayItemNumber'] ?? '-') : element[column] }}
        </td>
      </div>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
  <mat-paginator
  [ngClass]="{ 'd-none': dataSource.data.length < 1 }"
  [length]="dataSource.data.length"
  [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons
></mat-paginator>
</ng-container>
